/** Public endpoints that may still send Authorization when the client has a session. */
export const PUBLIC_OPTIONAL_AUTH_PATH_SUFFIXES = ["/resend-verification"] as const;

export function isPublicOptionalAuthPath(pathname: string | null): boolean {
  if (!pathname) {
    return false;
  }

  return PUBLIC_OPTIONAL_AUTH_PATH_SUFFIXES.some((suffix) => pathname.endsWith(suffix));
}

export function shouldStripAuthHeaderOnPublicRequest(pathname: string | null): boolean {
  return !isPublicOptionalAuthPath(pathname);
}
